import { render } from "./Contract.vue?vue&type=template&id=2a26f879&scoped=true"
import script from "./Contract.vue?vue&type=script&lang=js"
export * from "./Contract.vue?vue&type=script&lang=js"

import "./Contract.vue?vue&type=style&index=0&id=2a26f879&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a26f879"

export default script